
import { DatasetContentDiff, PathPrescaleDiff, PathPrescale } from '@/types';
import Vue, {PropType} from 'vue'
const _ = require('lodash');
export default Vue.extend({
  name: 'DatasetChangeView',
   data() {
    return {
     
    };
  },
  components :{
  },
  methods: {
   
  },
  computed: {
    

  },
  props:{
    datasetChanges: {type : Object as PropType<DatasetContentDiff>, required : true}
  }
  
})
